@if (canViewTeam) {
  <lib-container>
    
    <div class="title-search-container">
      <div class="page-title">Team Assessments</div> 

      <mat-form-field class="search-bar" actions appearance="outline" [formGroup]="form">
        <mat-label>Search</mat-label>
        <input matInput type="text" formControlName="search">
        <button matSuffix mat-icon-button [disabled]="form.invalid" (click)="clearSearch()">
          <mat-icon *ngIf="form.invalid">search</mat-icon>
          <mat-icon *ngIf="form.valid">close</mat-icon>
        </button>
      </mat-form-field>
    </div>

    <div #statusChip class="filters">
      <span class="status-filter" (click)="showStatusMenu()">
        <mat-icon>add_circle_outline</mat-icon>
        {{ applied_status }}
      </span>
    
      <span class="clear-filter" (click)="clearFilters()">Clear</span>

    
      @if (isStatusMenuVisible) {
        <div #statusMenu class="container" >
          <span class="form-container">
            <p class="title"><strong>Filter by Status</strong></p>

            <mat-form-field appearance="outline" class="form">
              <mat-label> 
                <strong>{{ applied_status }}</strong> 
              </mat-label>
              <mat-select (selectionChange)="onOptionChange($event.value)">
                <mat-option (click)="$event.stopPropagation()" [value]=STATUS.OPEN>{{ STATUS.OPEN }}</mat-option>
                <mat-option (click)="$event.stopPropagation()" [value]=STATUS.DONE>{{ STATUS.DONE }}</mat-option>
                <mat-option (click)="$event.stopPropagation()" [value]=STATUS.OVERDUE>{{ STATUS.OVERDUE }}</mat-option>
              </mat-select>
            </mat-form-field> 

            <span>
              <button class="button" (click)="statusFilter()">Apply</button>
            </span>
          </span>
        </div>
      }
      <span class="send-reminder-button">
        @if (applied_status === STATUS.OPEN || applied_status === STATUS.OVERDUE) {
          <lib-button (click)="reminderInBulk()">Send Reminder</lib-button>
        }
      </span>
      <span class="approve-button">
        @if (applied_status === STATUS.DONE) {
          <lib-button (click)="approveInBulk()">Approve</lib-button>
        }
      </span>
    </div>
    
    @if (isMobileView) {
      <div class="expand-button" (click)="toggleExpand()">
        {{ isExpanded ? 'Show Less' : 'Show All' }}
      </div>
    }

    <div class="no-results-message" *ngIf="!loading && noResults">
      No assessments match your search criteria.
    </div>

    <div>
      <lib-content-loader *ngIf="loading"></lib-content-loader>

      <table class="team-assessments" *ngIf="team_assessments.length > 0 && !loading" mat-table [dataSource]="sorted_data"
        matSort (matSortChange)="sortData($event)">

        <ng-container [matColumnDef]=COLUMNS.CHECKBOX>
          <th class="checkbox-header" mat-header-cell *matHeaderCellDef>
            @switch(applied_status) {
              @case (STATUS_DEFAULT) {}
            @default {
              <div style="display: flex; align-items: center;">
                <span style="margin-right: 8px;">
                  <mat-checkbox 
                    (change)="selectAll($event)"
                    [checked]="isAllSelected()"
                    color="primary"
                  ></mat-checkbox> 
                </span>
                <span>
                  Select All
                </span>
              </div>
            }
          }
          </th> 
          <td mat-cell *matCellDef="let ref, let i = index">
            @if (applied_status !== STATUS_DEFAULT) {
              <mat-checkbox
                (change)="onCheck($event, ref)"
                [checked]="selection.includes(ref)"
                (click)="$event.stopPropagation()"
                color="primary"
              ></mat-checkbox>
            }
          </td>
        </ng-container>

        <ng-container [matColumnDef]=COLUMNS.NAME>
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
          <td class="name" mat-cell *matCellDef="let ref">{{ ref.first_name + " " + ref.last_name }}</td>
        </ng-container>

        <ng-container [matColumnDef]=COLUMNS.ASSESSMENT>
          <th mat-header-cell *matHeaderCellDef>RESPECT Assessment</th>
          <td mat-cell *matCellDef="let ref">{{ ref.assessment_name }}</td>
        </ng-container>

        <ng-container [matColumnDef]=COLUMNS.STATUS>
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell class="statuses" *matCellDef="let ref">

            <span *ngIf="ref.days_remaining > 0" matTooltip="{{ ref.close_dt }} ">
              <mat-basic-chip class="open">Open</mat-basic-chip>
            </span>

            <span *ngIf="ref.days_remaining < 0" matTooltip="{{ getOverdueDays(ref.days_remaining) }} days overdue">
              <mat-basic-chip class="overdue">Overdue</mat-basic-chip>
            </span>
            <span *ngIf="ref.completed_at">
              <mat-basic-chip class="completed">Done</mat-basic-chip>
            </span>

          </td>
        </ng-container>

        <ng-container [matColumnDef]=COLUMNS.ASSIGNED>
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Assigned</th>
          <td mat-cell *matCellDef="let ref">{{ ref.created_at | date:'MM/dd/YYYY' }}</td>
        </ng-container>

        <!-- Completed Column with Days Remaining -->
        <ng-container [matColumnDef]=COLUMNS.COMPLETED>
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Completed</th>
          <td mat-cell *matCellDef="let ref">
            <span *ngIf="ref.completed_at">
              {{ getAssessmentStatus(ref) }}
            </span>
          </td>
        </ng-container>

        <ng-container [matColumnDef]=COLUMNS.ITERATION>
          <th mat-header-cell *matHeaderCellDef>Iteration</th>
          <td mat-cell *matCellDef="let ref">{{ ref.iteration }}</td>
        </ng-container>

        <ng-container [matColumnDef]=COLUMNS.WORKPLACE>
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Workplace</th>
          <td mat-cell *matCellDef="let ref">{{ ref.workplace }}</td>
        </ng-container>

        <ng-container [matColumnDef]=COLUMNS.COMPANY>
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Org</th>
          <td mat-cell *matCellDef="let ref">{{ ref.org_name }}</td>
        </ng-container>

        <ng-container [matColumnDef]=COLUMNS.COHORT>
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Cohort</th>
          <td mat-cell *matCellDef="let ref">{{ ref.cohort_name }}</td>
        </ng-container>

        <!-- Actions Column -->
        <ng-container [matColumnDef]=COLUMNS.ACTIONS>
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let ref, let i = index" class="mat-column-actions">

            <!-- Ellipsis Menu-->
            <mat-icon class="icon" data-testid="row-menu-trigger" [matMenuTriggerFor]="team_menu" (click)="$event.stopPropagation()">more_horiz
            </mat-icon>

            <mat-menu #team_menu="matMenu">
              <div class="menu-actions">Actions</div>

              <mat-divider></mat-divider>

              @if (ref.completed_at && (ref.require_approval === 0 || (ref.require_approval === 1 && ref.approved_at))) {
                <button mat-menu-item>
                  <span class="options" (click)="view(ref)">View Report</span>
                </button>

                <button
                  mat-menu-item
                  type="button"
                  data-testid="download-report-button"
                  [disabled]="downloadingId === ref.org_person_assessment_id"
                  [attr.aria-busy]="downloadingId === ref.org_person_assessment_id"
                  matTooltip="Preparing this report"
                  [matTooltipDisabled]="downloadingId !== ref.org_person_assessment_id"
                  (click)="downloadReport(ref)">
                  <span class="options">Download PDF</span>
                  @if (downloadingId === ref.org_person_assessment_id) {
                    <mat-spinner data-testid="download-spinner" diameter="18" mode="indeterminate"></mat-spinner>
                  }
                </button>
              }

              @if (ref.completed_at && ref.require_approval === 1 && !ref.approved_at) {
                <button mat-menu-item>
                  <span class="options" (click)="approve(ref)">Approve</span>
                </button>
                <button mat-menu-item>
                  <span class="options" (click)="view(ref)">View Report</span>
                </button>

                <button
                  mat-menu-item
                  type="button"
                  data-testid="download-report-button"
                  [disabled]="downloadingId === ref.org_person_assessment_id"
                  [attr.aria-busy]="downloadingId === ref.org_person_assessment_id"
                  matTooltip="Preparing this report"
                  [matTooltipDisabled]="downloadingId !== ref.org_person_assessment_id"
                  (click)="downloadReport(ref)">
                  <span class="options">Download PDF</span>
                  @if (downloadingId === ref.org_person_assessment_id) {
                    <mat-spinner data-testid="download-spinner" diameter="18" mode="indeterminate"></mat-spinner>
                  }
                </button>
                }

              @if (!ref.completed_at) {
                <button mat-menu-item>
                  <span class="options" (click)="assign(ref)">Assign</span>
                </button>

                <button mat-menu-item>
                  <span class="options" (click)="reminder([ref])">Send Reminder</span>
                </button>

                <button mat-menu-item>
                  <span class="options" (click)="cancel(ref)">Unassign</span>
                </button>
              }

              <div class="menu-actions">Connections</div>

              <mat-divider></mat-divider>

              <button mat-menu-item>
                <span class="options" (click)="goToProfile(ref.person_id)">View Profile</span>
              </button>
            </mat-menu>
          </td>
        </ng-container>

        <!-- Header and Row Definitions -->
        <tr mat-header-row *matHeaderRowDef="isMobileView && !isExpanded ? TEAM_ASSESSMENT_COLUMNS_MOBILE_VIEW_KEYS : MY_COLUMN_KEYS"></tr>
        <tr
          class="row"
          data-testid="assessment-row"
          mat-row
          *matRowDef="let row; columns: isMobileView && !isExpanded ? TEAM_ASSESSMENT_COLUMNS_MOBILE_VIEW_KEYS : MY_COLUMN_KEYS; let i = index"
          (click)="viewRow(row, i)">
        </tr>
      </table>

      <div *ngIf="team_assessments.length === 0 && !loading">
        <p>No current assessments found</p>
      </div>

    </div>
  </lib-container>
}